import React, { useState } from 'react';
import tarotcard from "../assets/zodiacSign/lovetarot.png";
import dailytarot from "../assets/tarotpageImage/dailytarot.png";
import breakuptarot from "../assets/tarotpageImage/breakuptarot.png";
import careertarot from "../assets/tarotpageImage/careertarot.png";
import newtarot from "../assets/tarotpageImage/newtarot.png";
import onetarot from "../assets/tarotpageImage/onetarot.png";
import yesnotarot from "../assets/tarotpageImage/yesnotarot.png";
import flirttarot from "../assets/tarotpageImage/flirttarot.png";
import astrotarot from "../assets/tarotpageImage/astrotarot.jpg";
import astrotarot2 from "../assets/tarotpageImage/astrotarot2.jpg";
import dailyHoroscope from "../assets/rootimg/kundlicomp.png";
import rings from "../assets/rootimg/two-rings.png";
import compatibility from "../assets/rootimg/compatibility.png";
import Footer from '../home/Footer';
import Queryform from './Queryform';
import { Link, Navigate, useNavigate } from 'react-router';
import { FaLongArrowAltRight } from "react-icons/fa";
import astrology from "../assets/tarotpageImage/astroimg.jpg";
import Navbar from '../home/Navbar';

const Tarot = () => {
  const [isActive, setIsActive] = useState(null);
  const [isActive1, setIsActive1] = useState(null);
  const [isActive2, setIsActive2] = useState(null);
  const navigate = useNavigate();
  const navigatetarot = (link) => {
    navigate(link);
  }

  const kundliClick = (e) => {
    e.preventDefault();
    navigate('/kundlimatching');
  }
  const horoscopeClick = (e) => {
    e.preventDefault();
    navigate('/horoscope');
  }
  const compatibilityClick = (e) => {
    e.preventDefault();
    navigate('/compatibility');
  }

  const cards = [
    {
      title: "Daily Tarot",
      description: "Kickstart your day with this reading to get pumped for all the possibilities ahead.",
      imgAlt: "Daily Tarot",
      image: dailytarot,
      link: '/daily/tarot'
    },
    {
      title: "Daily Love Tarot",
      description: "Discover what’s in store for your love life each day with your Love Tarot reading.",
      imgAlt: "Daily Love Tarot",
      image: tarotcard,
      link: '/love/tarot'
    },
    {
      title: "Daily Career Tarot",
      description: "Get your Daily Career Tarot reading before heading to work or exploring a new job opportunity.",
      imgAlt: "Daily Career Tarot",
      image: careertarot,
      link: '/career/tarot'
    },
    {
      title: "Yes/No Tarot",
      description: "This popular reading provides a clear yes or no answer, along with practical advice you can act on.",
      imgAlt: "Yes/No Tarot",
      image: yesnotarot,
      link: '/yes&no/tarot'
    },
    {
      title: "Love Potential Tarot",
      description: "Before diving too deep into a romance, consult the cards for guidance.",
      imgAlt: "Love Potential Tarot",
      image: onetarot,
      link: '/lovepotential/tarot'
    },
    // {
    //   title: "Breakup Tarot",
    //   description: "Gain the clarity you need on why the relationship ended and how to move forward.",
    //   imgAlt: "Breakup Tarot",
    //   image: breakuptarot,
    //   link: '/breakup/tarot'
    // },
    // {
    //   title: "One Card Tarot Reading",
    //   description: "Uncover the answers to your questions with a single card tarot reading.",
    //   imgAlt: "One Card Tarot Reading",
    //   image: newtarot,
    //   link: '/onecard/tarot'
    // },
    {
      title: "Daily Flirt Tarot",
      description: "Crushing on someone but unsure of your next move?",
      imgAlt: "Daily Flirt Tarot",
      image: flirttarot,
      link: '/flirt/tarot'
    },
  ];

  return (
    <>
      <div className="min-h-screen bg-gradient-to-r from-white to-success/40 text-gray-900 pb-10">
        <main>
          <Navbar />
          {/* Title Section */}
          <div className="text-center mb-8 mt-8 sm:mb-10 sm:mt-10 md:mb-12 md:mt-12">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-serif text-secondary font-bold">TAROT</h1>
            <p className="text-sm font-serif md:text-lg text-secondary mt-4">
              What does the future have in store for you? Get the answers you need with these Tarot readings.
            </p>
          </div>

          {/* Card Grid Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-10 px-4 sm:px-8 md:px-12 lg:px-44 text-center">
            {cards.map((card, index) => (
              <div
                key={index}
                className="flex flex-col cursor-pointer rounded-md items-center"
                onMouseEnter={() => setIsActive(index)}
                onMouseLeave={() => setIsActive(null)}
                onClick={() => navigatetarot(card.link)}

              >
                <div className="w-16 h-16 sm:w-20 sm:h-20 mb-3 sm:mb-4">
                  <img
                    src={card.image}
                    alt={card.imgAlt}
                    className={`w-full h-full object-contain transition-all duration-300 ease-in-out ${isActive === index ? "scale-[1.15]" : ""
                      }`}
                  />
                </div>
                <h2
                  className={`text-base sm:text-lg md:text-xl font-semibold text-primary ${isActive === index ? "underline" : ""
                    }`}
                >
                  {card.title}
                </h2>
                <p className="text-xs sm:text-sm">{card.description}</p>
              </div>
            ))}
          </div>
        </main>

        {/* What is Tarot Section */}
        <section className="mt-10 px-4 sm:px-12 md:px-20 lg:px-44">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-10">
            <div className="text-justify lg:w-2/3">
              <h3 className="text-xl sm:text-2xl md:text-3xl text-secondary font-semibold">What is Tarot?</h3>
              <p className="mt-2 text-sm sm:text-base">
                Tarot is an ancient system of divination that blends symbolism with intuition to provide insights into the past, present, and future. It involves a 78-card deck, with readings typically performed by a skilled practitioner, though anyone can engage in a tarot reading with practice. During a reading, the tarot reader draws and interprets cards in response to a seeker’s questions or concerns.
              </p>
              <p className="mt-2 text-sm sm:text-base">
                Each card in the deck carries its own distinct symbolism and meaning. For instance, The Fool may symbolize innocence and new beginnings, while The Magician often represents desire and manifestation. While some perceive tarot as a mystical or supernatural tool, others view it as a reflection of the reader’s subconscious or an exploration of the seeker’s thoughts and emotions.
              </p>
              {/* Additional text here */}
              <div>
                <h3 className="text-xl sm:text-2xl md:text-3xl text-secondary font-semibold mt-5">
                  The Beginner's Guide to Tarot
                </h3>
                <div
                  className=""
                  onMouseEnter={() => setIsActive1(true)}
                  onMouseLeave={() => setIsActive1(false)}
                >
                  <h3 className={`text-lg sm:text-2xl font-semibold mt-2 mb-1 ${isActive1 ? "" : ""}`}>How To Read Tarot Cards</h3>
                  <div className="flex flex-col sm:flex-row gap-6">
                    <img
                      src={astrotarot}
                      alt="tarot.jpg"
                      className={`w-full h-40 sm:w-64 object-contain transition-all duration-300 ease-in-out ${isActive1 ? "scale-[1.02]" : ""
                        }`}
                    />
                    <div>
                      <p className="mt-4 text-sm sm:text-base">
                        Mastering the Tarot involves getting familiar with the symbolism that shapes each card. There are countless ways to interpret the deck, and as your understanding deepens, your unique reading style will naturally develop.
                      </p>
                      <div className={`flex flex-row mt-2 ${isActive1 ? "hover:text-blue-600" : ""}`}>
                        <Link className="">CONTINUE READING</Link>
                        <FaLongArrowAltRight className="mt-1 ml-1" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  <hr className="border-secondary border-[1.5px] w-full mt-10" />
                  <p className="text-center mt-5">
                    Discover your highest truth with the guidance of a gifted psychic reader.
                  </p>
                  <Link className="text-center">Click here to claim your free reading!</Link>
                  <hr className="border-secondary border-[1.5px] w-full mt-5 mb-10" />
                </div>

                <div className=''
                  onMouseEnter={() => setIsActive2(true)}
                  onMouseLeave={() => setIsActive2(false)}
                >
                  <h3 className="text-lg sm:text-2xl font-semibold mt-2 mb-1">Learn About Tarot Card Reading</h3>
                  <div className="flex flex-col justify-center items-center sm:flex-row gap-6">
                    <img
                      src={astrotarot2}
                      alt="tarot.jpg"
                      className={`w-full h-40 sm:w-64 object-contain transition-all duration-300 ease-in-out ${isActive2 ? "scale-[1.02]" : ""
                        }`}
                    />
                    <div>
                      <p className="text-sm sm:text-base">
                        Learn what each card of the tarot deck means the major arcana, the minor arcana, they're all here.
                      </p>
                      <div className="flex flex-row mt-2 hover:text-blue-600">
                        <Link className="">CONTINUE READING</Link>
                        <FaLongArrowAltRight className="mt-1 ml-1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Addvisment section */}
            {/* parent div */}
            <div className='w-auto lg:h-[900px] scroll-smooth'>
              {/* child div */}
              <div className="bg-white lg:sticky lg:top-6 text-primary rounded-lg shadow-lg max-w-sm ">
                <div className="flex justify-center">
                  <img
                    src={astrology}
                    alt="Astrology placeholder"
                    className="w-full h-48 bg-[#01010d] object-contain"
                  />
                </div>
                <h2 className="text-3xl font-bold mt-2 text-center">AstroTellers</h2>
                <div className='text-justify'>
                  <p className="text-center text-2xl">
                    Your Personalized
                  </p>
                  <p className="text-center text-2xl -mt-2">
                    Cosmic Membership
                  </p>
                </div>
                <p className="mx-4 text-center text-sm mt-2 mb-2">
                  Daily, weekly, monthly, and yearly personalized astrological guidance at your fingertips.
                </p>
                <div className="text-center">
                  <button
                  onClick={() => navigate('/comming-soon')}
                  className="bg-primary text-white py-2 px-4 mb-4 rounded-lg hover:bg-success hover:shadow-xl transition duration-300">
                    Join Astrology Plus
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="mt-8 flex flex-col ml-4 sm:ml-8 md:ml-16 lg:ml-16 mr-4 sm:mr-8 md:mr-16 lg:mr-16 justify-center items-center">
          <h1 className="text-center text-lg sm:text-xl md:text-2xl text-secondary mt-8 font-bold">
            Recommended Reports For You
          </h1>
          {/* Parent Card div */}
          <div className="flex flex-wrap gap-5 justify-center mt-5">
            {/* Card 1 */}
            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
              <div className="flex flex-col items-center">
                <img
                  src={rings}
                  alt="kundli.png"
                  className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-center text-secondary">Kundli Matching</h3>
                  <p className="text-justify text-xs sm:text-sm md:text-base m-3 mb-4">
                    Kundli Matching helps you find a match for your astrological traits and preferences. By comparing your birth
                    chart with others in the database, you can find a person who shares your similarities, characteristics, and
                    compatible energies.
                  </p>
                  <button
                    onClick={kundliClick}
                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                  >
                    Match Kundli
                  </button>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
              <div className="flex flex-col items-center">
                <img
                  src={dailyHoroscope}
                  alt="daily-horoscope.png"
                  className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Daily Horoscope</h3>
                  <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-6">
                    Get your personalized daily horoscope and insights for the day ahead. Stay prepared and make the
                    most of your day with astrological guidance to navigate challenges, seize opportunities, and align with cosmic energy.
                  </p>
                  <button
                    onClick={horoscopeClick}
                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                  >
                    View Horoscope
                  </button>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
              <div className="flex flex-col items-center">
                <img
                  src={compatibility}
                  alt="daily-horoscope.png"
                  className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Compatibility</h3>
                  <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-4">
                    Compatibility helps you understand how well your astrological traits
                    align with those of another person. By comparing your birth chart with
                    others in the database, you can find a person who shares your
                    similarities and characteristics.
                  </p>
                  <button
                    onClick={compatibilityClick}
                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                  >
                    Check Compatibility
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>


        <Queryform />
      </div>
      <Footer />
    </>


  );
};

export default Tarot;